import * as moment from 'moment'

export class EventId {
    constructor(public ncpdp?: string, public prescriptionNumber?: number, public fillDate?: Date) {
    }

    get eventValid(): boolean {
        return this.ncpdp !== undefined || this.prescriptionNumber !== undefined;
    }

    get eventId(): string {
        return `${this.ncpdp}-${this.prescriptionNumber}-${moment(this.fillDate).format('YYYYMMDD')}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/eventId.model.ts